import baseAPI from '@/api/base';
import { EditFile, GetFile, RegisterFile } from '@/dtos/file.dto';
import {
  DELETE_FILE_URL,
  EDIT_FILE_URL,
  GET_FILE_URL,
  REGISTER_FILE_URL,
  TOGGLE_FILE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class File {
  static getFiles = async (getFile: GetFile): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_FILE_URL, {
      params: getFile,
    });
    console.log('response', response);
    return response;
  };

  static registerFile = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_FILE_URL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    console.log('response', response);
    return response;
  };

  static editFile = async (formData: FormData): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_FILE_URL, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response;
  };

  static toggleFileIsActive = async (
    editFile: EditFile
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_FILE_IS_ACTIVE_URL,
      {
        ...editFile,
      }
    );
    return response;
  };

  static deleteFile = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_FILE_URL}/${userId}`
    );
    return response;
  };
}

export default File;
